'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setDifficulty = setDifficulty;
exports.addDifficulty = addDifficulty;
exports.addCurrentQuestion = addCurrentQuestion;
exports.addCorrectAnswersCounter = addCorrectAnswersCounter;
exports.setCorrectAnswersCounter = setCorrectAnswersCounter;
exports.setCurrentQuestion = setCurrentQuestion;
exports.toggleInitial = toggleInitial;
exports.updateDataFromLevel = updateDataFromLevel;
exports.resetQuestionValues = resetQuestionValues;
exports.setSliderValue = setSliderValue;
exports.setAnswerIndex = setAnswerIndex;
exports.setShowingAnswer = setShowingAnswer;
exports.setRightAnswer = setRightAnswer;

var _rtveUtil = require('lib/rtveLab/rtveUtil');

var _rtveUtil2 = _interopRequireDefault(_rtveUtil);

var _es = require('../i18n/es');

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_DIFFICULTY = 'redux-example/ADD_DIFFICULTY';
var SET_DIFFICULTY = 'redux-example/SET_DIFFICULTY';
var TOGGLE_INITIAL = 'redux-example/TOGGLE_INITIAL';
var UPDATE_DATA = 'redux-example/UPDATE_DATA';
var ADD_CURRENT_QUESTION = 'redux-example/ADD_CURRENT_QUESTION';
var ADD_CORRECT_ANSWERS_COUNTER = 'redux-example/ADD_CORRECT_ANSWERS_COUNTER';
var SET_CORRECT_ANSWERS_COUNTER = 'redux-example/SET_CORRECT_ANSWERS_COUNTER';
var SET_CURRENT_QUESTION = 'redux-example/SET_CURRENT_QUESTION';
var SET_ANSWER_INDEX = 'redux-example/SET_ANSWER_INDEX';
var SET_SLIDER_VALUE = 'redux-example/SET_SLIDER_VALUE';
var SET_SHOWING_ANSWER = 'redux-example/SET_SHOWING_ANSWER';
var SET_RIGHT_ANSWER = 'redux-example/SET_RIGHT_ANSWER';
var RESET_QUESTION_VALUES = 'redux-example/RESET_QUESTION_VALUES';

var initialState = {
  level: 0,
  initial: true,
  currentQuestion: 0,
  correctAnswersCounter: 0,
  actualData: [],
  showingAnswer: false,
  rightAnswer: false,
  answerIndex: -1,
  sliderValue: -1
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ADD_DIFFICULTY:
      var level = state.level;

      return (0, _extends3.default)({}, state, {
        level: level + 1
      });
    case SET_DIFFICULTY:
      return (0, _extends3.default)({}, state, {
        level: action.newState
      });
    case TOGGLE_INITIAL:
      return (0, _extends3.default)({}, state, {
        initial: action.newState
      });
    case ADD_CORRECT_ANSWERS_COUNTER:
      var correctAnswersCounter = state.correctAnswersCounter;

      return (0, _extends3.default)({}, state, {
        correctAnswersCounter: correctAnswersCounter + 1
      });
    case ADD_CURRENT_QUESTION:
      var currentQuestion = state.currentQuestion;

      return (0, _extends3.default)({}, state, {
        currentQuestion: currentQuestion + 1
      });
    case SET_CORRECT_ANSWERS_COUNTER:
      return (0, _extends3.default)({}, state, {
        correctAnswersCounter: action.newState
      });
    case SET_CURRENT_QUESTION:
      return (0, _extends3.default)({}, state, {
        currentQuestion: action.newState
      });
    case SET_ANSWER_INDEX:
      return (0, _extends3.default)({}, state, {
        answerIndex: action.newState
      });
    case SET_SLIDER_VALUE:
      return (0, _extends3.default)({}, state, {
        sliderValue: action.newState
      });
    case SET_SHOWING_ANSWER:
      return (0, _extends3.default)({}, state, {
        showingAnswer: action.newState
      });
    case SET_RIGHT_ANSWER:
      return (0, _extends3.default)({}, state, {
        rightAnswer: action.newState
      });
    case RESET_QUESTION_VALUES:
      return (0, _extends3.default)({}, state, {
        answerIndex: -1,
        sliderValue: -1,
        showingAnswer: false,
        rightAnswer: false
      });
    case UPDATE_DATA:
      return (0, _extends3.default)({}, state, {
        actualData: [].concat((0, _toConsumableArray3.default)(action.newState))
      });
    default:
      return state;
  }
}

function setDifficulty(newValue) {
  return function (dispatch, getState) {
    dispatch({
      type: SET_DIFFICULTY,
      newState: newValue
    });

    dispatch(setCurrentQuestion(0));
    dispatch(setCorrectAnswersCounter(0));
    dispatch(updateDataFromLevel());
  };
}

function addDifficulty() {
  return function (dispatch, getState) {
    dispatch({
      type: ADD_DIFFICULTY
    });

    dispatch(setCurrentQuestion(0));
    dispatch(setCorrectAnswersCounter(0));
    dispatch(updateDataFromLevel());
  };
}

function addCurrentQuestion() {
  return {
    type: ADD_CURRENT_QUESTION
  };
}

function addCorrectAnswersCounter() {
  return {
    type: ADD_CORRECT_ANSWERS_COUNTER
  };
}

function setCorrectAnswersCounter(val) {
  return {
    type: SET_CORRECT_ANSWERS_COUNTER,
    newState: val
  };
}
function setCurrentQuestion(val) {
  return {
    type: SET_CURRENT_QUESTION,
    newState: val
  };
}

function toggleInitial() {
  return function (dispatch, getState) {
    var _getState = getState(),
        quiz = _getState.quiz;

    dispatch({
      type: TOGGLE_INITIAL,
      newState: !quiz.initial
    });
  };
}

function updateDataFromLevel() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        quiz = _getState2.quiz;

    var newData = _rtveUtil2.default.shuffleArray(_es2.default.Quiz.questions.filter(function (question) {
      return question.difficulty === quiz.level + 1;
    })).slice(0, 10);
    dispatch({
      type: UPDATE_DATA,
      newState: newData
    });
  };
}

function resetQuestionValues() {
  return {
    type: RESET_QUESTION_VALUES
  };
}

function setSliderValue(val) {
  return {
    type: SET_SLIDER_VALUE,
    newState: val
  };
}

function setAnswerIndex(val) {
  return {
    type: SET_ANSWER_INDEX,
    newState: val
  };
}

function setShowingAnswer(val) {
  return {
    type: SET_SHOWING_ANSWER,
    newState: val
  };
}

function setRightAnswer(val) {
  return {
    type: SET_RIGHT_ANSWER,
    newState: val
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/quiz.js
// module id = 726
// module chunks = 0